// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AhJo0","type":"styles_type__23ijK","choices":"styles_choices__XINOw"};